
  import { mapGetters } from 'vuex';
  import { Address } from '@/scripts/address';
  import { ADDRESS_FIELDS } from '@/constants/addresses';
  export default {
    props: {
      buttonText: { type: String, required: true },
      disableAutoFocus: { type: Boolean, default: false },
      searchLabel: { type: String, required: true }
    },
    data () {
      return {
        address: null,
        editProfile: false,
        addressFields: ADDRESS_FIELDS,
        formDisabled: false,
        bundleIncludes: ['Broadband']
      };
    },
    computed: {
      ...mapGetters('order', { order: 'get' }),
      ...mapGetters('products', { bundle: 'get' }),
      ...mapGetters('providers', { providers: 'getList' }),
      ...mapGetters('user', { customer: 'getCustomer', user: 'get' }),
      canShowUserAddressCard () {
        return this.$store.getters['user/canShowUserAddressCard'];
      },
      showUserProfileCard () {
        if (this.editProfile) {
          return false;
        }
        return this.canShowUserProfileCard;
      },
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      formattedAddressParts () {
        if (this.canonicalAddress) {
          const addressParts = this.addressFields.map(field =>
            this.canonicalAddress[field === 'eircode' ? 'displayEircode' : field]
          );
          return addressParts
            .map((part, index) => {
              if (part !== undefined) {
                return {
                  text: part,
                  class: index < addressParts.length - 2 ? 'bold' : 'light'
                };
              }
              return null;
            })
            .filter(part => part !== null);
        } else {
          return [];
        }
      },
      formParams () {
        const bundles = this.bundleIncludes.reduce((obj, item) => {
          obj[item] = true;
          return obj;
        }, {});
        const commsearch = {
          ...this.search,
          ...bundles,
          address_attributes: this.canonicalAddress
        };
        delete commsearch.address_attributes.id;
        if (this.search.current_provider_id === '' || this.search.current_provider_id === 'other') {
          delete commsearch.current_provider_id;
        }
        const id = this.search.id;
        return { commsearch, method: id ? 'get' : 'post' };
      },
      search () {
        return this.$store.getters['search/get'];
      },
      storedAddress () {
        return this.$store.getters['utils/getAddress']('default');
      },
      user () {
        return this.$store.getters['user/get'];
      }
    },
    watch: {
      storedAddress (newVal) {
        if (newVal !== null) {
          this.address = newVal;
        }
      }
    },
    created () {
      if (this.canShowUserAddressCard) {
        this.$store.commit('utils/setAddress', this.customer.supply_address);
        this.address = this.customer.supply_address;
      }
    },
    methods: {
      editAddress () {
        this.address = null;
        this.editProfile = true;
      },
      async proceed () {
        if (this.bundleIncludes.length === 0) {
          return;
        }
        this.formDisabled = true;

        const createdSearch = await this.$api('broadband/searches', this.formParams);
        const fetchedSearch = await this.$api(`broadband/searches/${createdSearch.id}`);

        this.$cookies.set('bonkers-ie-broadband-search', fetchedSearch.id);
        this.$store.commit('search/set', fetchedSearch);

        this.$router.push('/compare-tv-broadband-phone/your-results/');
      },
      updateSelectedItems (newVal) {
        this.bundleIncludes = newVal;
      }
    }
  };
